import React from 'react';
import { Alert, Typography } from '@mui/material';
import { formatDateTime } from '../common/util/datetime';
import { arrivalSummary } from './eta';

const TripArrival = ({ trip, maxAgeMs }) => {
  const summary = arrivalSummary(trip, maxAgeMs);
  return (
    <Alert severity={summary.severity} sx={{ my: 1 }}>
      <Typography>{`${summary.label}${summary.at ? `: ${formatDateTime(summary.at)}` : ''}`}</Typography>
      {summary.note && <Typography variant="body2">{summary.note}</Typography>}
    </Alert>
  );
};
export default TripArrival;
